module.exports = __webpack_public_path__ + "img/academy-marketing.294ebabc.png";